interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  /** Optional status accent — colors the value. */
  tone?: 'neutral' | 'good' | 'warn' | 'bad';
}

const TONE: Record<NonNullable<MetricCardProps['tone']>, string> = {
  neutral: 'text-slate-900',
  good: 'text-emerald-600',
  warn: 'text-amber-600',
  bad: 'text-rose-600',
};

export function MetricCard({ label, value, hint, tone = 'neutral' }: MetricCardProps) {
  return (
    <div className="card">
      <p className="text-sm font-medium text-slate-500">{label}</p>
      <p className={`mt-2 text-3xl font-semibold tracking-tight ${TONE[tone]}`}>{value}</p>
      {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    </div>
  );
}
